import { GroupCampaignsByYear } from "../../../types/profile/GroupCampaignsByYear";
import { GET_ALL_PROFILES_BY_ROLL } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface ProfilesByRollState extends BaseAsyncReducerState {
  success: boolean,
  found: boolean,
  message: string,
  grouped_campaigns: GroupCampaignsByYear[],
  unauthorized_access?: boolean
}

const initialState: ProfilesByRollState = {
  success: false,
  found: false,
  message: "",
  loading: false,
  error: false,
  grouped_campaigns: [],
  unauthorized_access: false
}

function getAllProfilesByRollReducer(state = initialState, action: AppAction) {
  return defaultAsyncReducer(state, action as AppAction, GET_ALL_PROFILES_BY_ROLL)
}

export default getAllProfilesByRollReducer;